/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RateRefreshRequest
 */
export interface RateRefreshRequest {
    /**
     * The hotel stay to refresh. Provide exactly one of hotel_stay_id or flight_id.
     * @type {string}
     * @memberof RateRefreshRequest
     */
    hotelStayId?: string | null;
    /**
     * The flight to refresh. Provide exactly one of hotel_stay_id or flight_id.
     * @type {string}
     * @memberof RateRefreshRequest
     */
    flightId?: string | null;
}

/**
 * Check if a given object implements the RateRefreshRequest interface.
 */
export function instanceOfRateRefreshRequest(value: object): value is RateRefreshRequest {
    return true;
}

export function RateRefreshRequestFromJSON(json: any): RateRefreshRequest {
    return RateRefreshRequestFromJSONTyped(json, false);
}

export function RateRefreshRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateRefreshRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hotelStayId': json['hotel_stay_id'] == null ? undefined : json['hotel_stay_id'],
        'flightId': json['flight_id'] == null ? undefined : json['flight_id'],
    };
}

export function RateRefreshRequestToJSON(json: any): RateRefreshRequest {
    return RateRefreshRequestToJSONTyped(json, false);
}

export function RateRefreshRequestToJSONTyped(value?: RateRefreshRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hotel_stay_id': value['hotelStayId'],
        'flight_id': value['flightId'],
    };
}

